import React, {useCallback, useEffect, useState} from 'react'
import PropTypes from 'prop-types'

import { TabAction } from './TabAction'
import * as my from '../form/field/MyForm'
import './styles.css'
import {IconTrash} from "../icons";
import {DeleteTabIconBtn} from "./UnderlinedTabs";
import {ModalConfirmDelete} from "../modals";
import {Trans, useTranslation} from "react-i18next";

export const VerticalTabs = ({
	className = '',
	activeTab = 0,
	tabs,
	action,
	onTabChange,
	onTabDelete,
	isCaps = false,
 	isMultiLangView = false,
}) => {
	const {t} = useTranslation()
	const [openTab, setOpenTab] = useState(activeTab)
	const [deleteModal, updateDeleteModal] = useState({isShow: false, itemId: false, tab: null});

	const openModalConfirmDelete = (tab) => updateDeleteModal((prevState) => ({ ...prevState, isShow: true, tab}))
	const closeModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: false, tab: null}))

	const doTabChange = useCallback((tab) => (event) => {
		event.preventDefault()
		onTabChange && onTabChange(tab.index)
		setOpenTab(tab.index)
	}, [onTabChange])

	const doTabDelete = React.useCallback((tab) => (event) => {
		event.preventDefault()
		event.stopPropagation()
		onTabDelete && tab.canDelete !== false && onTabDelete(tab.index)
		closeModalConfirmDelete()
	}, [onTabDelete])

	const onRemoveBtnClick = (tab) => (event) => {
		event.preventDefault()
		openModalConfirmDelete(tab)
	}

	useEffect(() => setOpenTab(activeTab), [activeTab])

	return (
		<my.Tabs data-multi-lang-view={!!isMultiLangView} className={className}>
			{/* className={`flex flex-row items-start justify-start tabs ${className}`} */}
			<my.TabItems data-vtab data-multi-lang-view={!!isMultiLangView}>
			{/* className="flex flex-wrap flex-col space-y-2" */}
				{
					tabs.map((tab, key) => {
						const active = openTab === tab.index
						return (
							<my.TabItem key={key}
													data-active={active}
													data-caps={isCaps}
													data-multi-lang-view={!!isMultiLangView}
							>
								<my.TabButton type='button'
															onClick={doTabChange(tab)}
															className={`tab-pill`}
															data-multi-lang-view={!!isMultiLangView}
								>
									{tab.title}
									{tab.canDelete ? (
										<>
											<DeleteTabIconBtn onClick={onRemoveBtnClick(tab)}><IconTrash size={20}/></DeleteTabIconBtn>

											<ModalConfirmDelete
												isOpen={deleteModal.isShow && tab.index === deleteModal.tab.index}
												itemIds={deleteModal.itemId}
												onCancel={closeModalConfirmDelete}
												onConfirm={doTabDelete(deleteModal.tab)}
												description={<Trans
													i18nKey={"modal.confirmdelete.description_tab"}
													components={{ b: <strong style={{textTransform: 'uppercase', color: `var(--it-text-red)`}} /> }}
													values={{tab: tab.title}}
												/>}
											/>
										</>
									) : null}
								</my.TabButton>
							</my.TabItem>
						)
					})
				}
				{ action && <TabAction {...action} /> }
			</my.TabItems>
			{/* <div className="ml-0"> */}
				{
					tabs.map((tab, key) => {
						const active = openTab === tab.index
						return (
							<my.TabContent key={key} data-active={active}>
							{/* className={`tab-content ${ !active ? 'hidden' : 'block' }`} */}
								{tab.content}
							</my.TabContent>
						)
					})
				}
			{/* </div> */}
		</my.Tabs>
	)
}
VerticalTabs.propTypes = {
	activeTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	onTabChange: PropTypes.func,
	onTabDelete: PropTypes.func,
	tabs: PropTypes.arrayOf(
			PropTypes.shape({
					index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
					content: PropTypes.element,
					title: PropTypes.any
			})
	).isRequired,
	action: PropTypes.shape({
			title:  PropTypes.string,
			icon: PropTypes.element,
			dropdownContent: PropTypes.element,
			onClick: PropTypes.func,
	})
}
